export function ratioToPercentage(value) {
  if (value == null || value === '') return null;
  const percentage = Number(value) * 100;
  return Number.isFinite(percentage) ? Number(percentage.toFixed(2)) : null;
}

export function percentageToRatio(value) {
  if (value == null || value === '') return null;
  const ratio = Number(value) / 100;
  return Number.isFinite(ratio) ? Number(ratio.toFixed(4)) : null;
}

export function formatPercentage(value, emptyValue = '—') {
  const percentage = ratioToPercentage(value);
  return percentage == null ? emptyValue : `${percentage}%`;
}

export function formatPercentageInput(value) {
  return value == null || value === '' ? '' : `${value}%`;
}

export function parsePercentageInput(value) {
  if (value == null) return '';
  return String(value).replace(/%/g, '').trim();
}
